import type React from 'react';

import { Link, Text } from '@change/ds-core-ui';

import { useGetStaticAssetUrl } from '@change-corgi/core-react/assets';
import { Translate, useI18n } from '@change-corgi/core-react/i18n';

const PLAY_STORE_URL =
	'https://play.google.com/store/apps/details?id=org.change.android&utm_source=internal&utm_medium=display_banner&utm_campaign=live_updates_on_the_go&utm_content=button&referrer=utm_source%3Dinternal%26utm_medium%3Ddisplay_banner%26utm_campaign%3Dlive_updates_on_the_go%26utm_content%3Dbutton';

export const Content: React.FC<{ onClickDownload: () => void }> = ({ onClickDownload }) => {
	const getStaticAssetUrl = useGetStaticAssetUrl();
	const { translate } = useI18n();

	return (
		<div className="flex flex-col gap-4">
			<Text variant="heading" size="xx-small" fontWeight="bold">
				<Translate value="corgi.app_download.bottom_banner_v2.mobile.headline" />
			</Text>
			<Text variant="body" size="small">
				<Translate value="corgi.app_download.bottom_banner_v2.mobile.description" />
			</Text>
			<Link href={PLAY_STORE_URL} target="_blank" onClick={onClickDownload}>
				<img
					src={getStaticAssetUrl('/images/google-play-get-it-on-badge-EN-black.svg')}
					alt={translate('corgi.app_download.bottom_banner_v2.download_on_google_app_store.image_alt_text')}
					className="h-[52px] w-[180px] min-w-[180px]"
				/>
			</Link>
		</div>
	);
};
